export function billingBlockFormServerValidationErrors(validationErrors) {
    return function (dispatch) {
        dispatch({type: 'BILLING-BLOCK-FORM-SERVER-VALIDATION-ERRORS', validationErrors});
    }
}

export function onBillingBlockFormSubmit() {
    return function (dispatch) {
        dispatch({type: 'ON-BILLING-BLOCK-FORM-SUBMIT'})
    }
}

export function onBillingBlockFormChange(name, value) {
    return function (dispatch) {
        dispatch({type: 'ON-BILLING-BLOCK-FORM-CHANGE', name, value});
    }
}

export function onBillingBlockFormModeChange(mode) {
    return function (dispatch) {
        dispatch({type: 'ON-BILLING-BLOCK-FORM-MODE-CHANGE', mode});
    }
}

export function cancelBillingBlockFormDispatch() {
    return function (dispatch) {
        dispatch({type: 'CANCEL-BILLING-BLOCK-FORM-DISPATCH'});
    }
}

export function setDefaultBillingBlockForm() {
    return function (dispatch) {
        // let { getSite } = getState();
        // let site_price = getSite && getSite.success && getSite.success.sitePrice && getSite.success.sitePrice.price
        dispatch({type: 'SET-DEFAULT-BILLING-BLOCK-FORM'});
    }
}

export function setDefaultBillingBlockFormUpdate() {
    return function (dispatch, getState) {
        let { getSite } = getState();
        let billable = getSite && getSite.success && getSite.success.billable
        dispatch({type: 'SET-DEFAULT-BILLING-BLOCK-FORM-FOR-UPDATE',billable});
    }
}

export function setSiteId(site_id) {
    return function (dispatch) {
         dispatch({type: 'SET-SITE-ID', site_id});
    }
}
// export function setOrganizationId(organization_id) {
//     return function (dispatch) {
//         dispatch({type: 'SET-BILLING-ID', organization_id});
//     }
// }

export function billingBlockError(error) {
    return function (dispatch) {
        dispatch({type: 'SET-BILLING-BLOCK-ERROR', error});
    }
}